import { useEffect } from 'react'
import PropTypes from 'prop-types'
import getAuthenticationConfiguration from 'utils/auth/authConfig'
import { OidcProvider } from '@axa-fr/react-oidc'
import { Authenticating } from 'components/login/Authenticating'
import { CallbackPage } from 'components/login/CallbackPage'
import { NotAuthenticated } from 'components/login/NotAuthenticated'
import { SessionExpired } from 'components/login/SessionExpired'
import { Forbidden } from '@totalsoft/rocket-ui'
import { getOidcConfigName } from 'utils/functions'
import { unregisterOidcServiceWorker } from 'utils/auth/serviceWorkerHandling'
import { env } from 'utils/env'

const disableServiceWorker = JSON.parse(env.REACT_APP_DISABLE_SERVICE_WORKER) || false

const AuthenticationProvider = props => {
  const { children } = props
  const configuration = getAuthenticationConfiguration()
  const configName = getOidcConfigName()

  useEffect(() => {
    if (disableServiceWorker) {
      unregisterOidcServiceWorker()
    }
  }, [])

  return (
    <OidcProvider
      configuration={configuration}
      configurationName={configName}
      authenticatingComponent={Authenticating}
      callbackSuccessComponent={CallbackPage}
      loadingComponent={NotAuthenticated}
      sessionLostComponent={SessionExpired}
      authenticatingErrorComponent={Forbidden}
    >
      {children}
    </OidcProvider>
  )
}

AuthenticationProvider.propTypes = { children: PropTypes.element.isRequired }

export default AuthenticationProvider
